<script setup lang="ts"></script>

<template>
  <v-container fluid>
    <v-row class="pa-15 mt-15">
      <v-col class="mt-13">
        <p class="text-title">
          <slot name="title"></slot>
        </p>

        <p class="text-description">
          <slot name="description"></slot>
        </p>

        <div class="mt-10">
          <slot name="form"></slot>
        </div>

        <div class="d-flex justify-end">
          <slot name="action"></slot>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped lang="scss">
.text-title {
  font-size: 30px;
  font-weight: 600;
  line-height: 34px;
  margin: 20px 0;
}

.text-description {
  font-size: 24px;
  line-height: 28px;
}
</style>
